import { logger } from "../utils/logger";

const isNetworkLogsEnabled = false;

const apiLogger = {
  request: (config) => {
    if (isNetworkLogsEnabled) {
      logger.log('%c[API Request]', 'color: blue; font-weight: bold;', {
        method: config.method?.toUpperCase(),
        url: config.url,
        headers: config.headers,
        params: config.params,
        data: config.data,
      });
    }
    return config;
  },

  response: (response) => {
    if (isNetworkLogsEnabled) {
      logger.log('%c[API Response]', 'color: green; font-weight: bold;', {
        url: response.config?.url,
        status: response.status,
        data: response.data,
      });
    }
    return response;
  },

  error: (error) => {
    if (isNetworkLogsEnabled) {
      console.error('%c[API Error]', 'color: red; font-weight: bold;', {
        message: error.message,
        url: error.config?.url,
        ...(error.response && {
          status: error.response.status,
          data: error.response.data,
        }),
      });
    }
    return Promise.reject(error);
  },
};

export default apiLogger;
